export const SCHEDULE = "schedule"
export const GROUP = "group"
export const FACILITY = "facility"
export const SPACE = "space"
export const SIMPLE = "simple"
export const DRAFT = "draft"
export const RETIRED = "retired"
export const isType = function isType(type) {
    return (c) => c?.type === type
}
export const isNotType = function isType(type) {
    return (c) => c?.type !== type
}

export const isSchedule = isType(SCHEDULE)
export const isGroup = isType(GROUP)
export const isDraft = isType(DRAFT)
export const isSimple = isType(SIMPLE)
export const isNotSchedule = isNotType(SCHEDULE)
export const isNotGroup = isNotType(GROUP)
export const isNotDraft = isNotType(DRAFT)
export const isNotSimple = isNotType(SIMPLE)
export const EDIT_TREE = "myTree"
export const LIVE_TREE = "myLive"
export const REVIEW_TREE = "myReview"
export const READY_TREE = "myReady"
export const PUBLISHED_TREE = "myPublishedTrees"
export const REGIME_IDS = [EDIT_TREE, LIVE_TREE, READY_TREE]
